import { DEFAULT_CURRENCY } from '@shared/constants';

export const toDecimal = (value: number | null | undefined, decimals = 2): number => {
  return Number(Number(value ?? 0).toFixed(decimals));
};

export const getFormattedPrice = (price: number | null | undefined = 0, currency = DEFAULT_CURRENCY) => {
  return currency + toDecimal(price).toFixed(2);
};
